import type { UIMessage } from "ai";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ChatbotEmptyState } from "src/components/GlobalChatbot/ChatbotEmptyState";
import { ChatbotMessageListSkeleton } from "src/components/GlobalChatbot/ChatbotMessageListSkeleton";
import { ChatbotThinkingBubble } from "src/components/GlobalChatbot/ChatbotThinkingBubble";
import { MessageBubble } from "src/components/GlobalChatbot/MessageBubble";

interface ChatbotMessageListProps {
	messages: UIMessage[];
	showThinking?: boolean;
	isLoading?: boolean;
}

export const ChatbotMessageList = ({
	messages,
	showThinking = false,
	isLoading = false,
}: ChatbotMessageListProps) => {
	const { t } = useTranslation();
	const bottomRef = useRef<HTMLDivElement>(null);

	// biome-ignore lint/correctness/useExhaustiveDependencies: scroll przy każdej nowej wiadomości / pojawieniu się loadera
	useEffect(() => {
		bottomRef.current?.scrollIntoView({ block: "end" });
	}, [messages.length, showThinking]);

	if (isLoading) {
		return <ChatbotMessageListSkeleton />;
	}

	if (messages.length === 0 && !showThinking) {
		return <ChatbotEmptyState />;
	}

	return (
		<div className="chatbot-message-list scroll">
			<div className="chatbot-message-list-date">
				{t("globalChatbot.history.today", "Dzisiaj")}
			</div>
			{messages.map((message) => (
				<MessageBubble key={message.id} message={message} />
			))}
			{showThinking && <ChatbotThinkingBubble />}
			<div ref={bottomRef} />
		</div>
	);
};
